<template>
    <div class="form">
        <Form
            ref="info"
            :label-width="80"
            :model="info"
            :rules="ruleValidate"
            :viewonly="isView"
        >
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="购方名称" prop="purchaser">
                        <Input
                            :maxlength="100"
                            v-model="info.purchaser"
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="业务名称" prop="busName">
                        <Input :maxlength="100" v-model="info.busName"></Input>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="合计金额" prop="totalAmount">
                        <input-number v-model="info.totalAmount"
                            ><span slot="append">元</span></input-number
                        >
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="价税合计" prop="amount">
                        <input-number v-model="info.amount"
                            ><span slot="append">元</span></input-number
                        >
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="开票日期" prop="invoiceTime">
                        <DatePicker
                            style="width: 100%"
                            transfer
                            type="date"
                            v-model="invoiceTime"
                            placeholder=""
                        ></DatePicker>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="发票类型" prop="invoiceType">
                        <Select v-model="info.invoiceType">
                            <Option
                                v-for="item in dict.invoiceType.toList()"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import { multiply } from "@/views/common/u-contract";

import { invoiceView, invoiceAdd, invoiceUpdate } from "@/api/invoice";
import dayjs from "dayjs";
export default {
    name: "i-invoice-form",
    props: {
        invoiceId: {
            type: [String, Number],
            default: "",
        },
        actionType: {
            type: [String, Number],
            default: "",
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.invoiceId,
                purchaser: "", // 购买方
                busName: "", // 业务名称
                totalAmount: "", // 合计金额
                amount: "", // 价税合计
                invoiceTime: "", // 开票时间
                invoiceType: "", // 发票类型
                ver: "",
            },
            isView: this.actionType === "2" ? true : false,
            dict: {
                invoiceType: this.$dict.NULL,
            },
        };
    },
    computed: {
        ruleValidate() {
            return this.isView
                ? {}
                : {
                      purchaser: [{ required: true, message: "购买方必填" }],
                      busName: [{ required: true, message: "业务名称必填" }],
                      totalAmount: [
                          { required: true, message: "合计金额必填" },
                      ],
                      amount: [{ required: true, message: "价税合计必填" }],
                      invoiceTime: [
                          { required: true, message: "开票时间必填" },
                      ],
                      invoiceType: [
                          { required: true, message: "发票类型必填" },
                      ],
                  };
        },
        invoiceTime: {
            get() {
                return this.info.invoiceTime
                    ? new Date(this.info.invoiceTime)
                    : "";
            },
            set(val) {
                this.info.invoiceTime = val
                    ? dayjs(val).format("YYYY-MM-DD HH:mm:ss")
                    : "";
            },
        },
    },
    methods: {
        fetch() {
            if (this.invoiceId) {
                return invoiceView(this.invoiceId);
            } else {
                return Promise.resolve();
            }
        },
    },
    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        const btns = [];
        if (this.actionType === "1" || this.actionType === "3") {
            btns.unshift({
                type: "default",
                name: "cancel",
                text: "取消",
            });
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        } else {
            btns.unshift({
                type: "default",
                name: "cancel",
                text: "关闭",
            });
        }
        this.$modal.updateBtns(btns);

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch(), this.$dict.get(["invoice_type"])])
                .then((args) => {
                    var [view, group] = args;

                    Object.assign(this.dict, group);

                    if (view) {
                        var viewData = view.data;
                        // 实体数据
                        if (viewData.entity) {
                            viewData = viewData.entity;
                            viewData.totalAmount /= 100;
                            viewData.amount /= 100;
                        }

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        );
                    }
                })
                .finally(() => {
                    next();
                });
        });

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info);
                    formData.totalAmount = multiply(formData.totalAmount);
                    formData.amount = multiply(formData.amount);

                    if (this.invoiceId) {
                        return invoiceUpdate(formData);
                    } else {
                        return invoiceAdd(formData);
                    }
                })
                .then((res) => {
                    if (this.invoiceId) {
                        this.$Message.success(this.$t("tips.update.success"));
                    } else {
                        this.$Message.success(this.$t("tips.add.success"));
                    }
                })
                .catch((err) => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    },
};
</script>

<style lang="scss" scoped></style>
